import React from "react";
import { GLBANOTICELINK } from "Utils/EnvVars";
import { faro } from "@grafana/faro-react";

const TermsAndConditions = ({ buttonText, isCashier }) => {
  buttonText = buttonText == null ? "submit" : buttonText;
  const styleClass = isCashier ? "cashier-termsAndConditions" : "termsAndConditions";
  const linkClick = (link) => faro.api.pushEvent(`User clicked on ${link}`);

  const termsLabel = (
    <div className={styleClass}>
      By clicking {buttonText.toUpperCase()}, I agree to the{" "}
      <a
        rel="noreferrer"
        className="link"
        target="_blank"
        href="https://www.vippreferred.com/terms-of-service"
        onClick={() => linkClick("Terms & Conditions")}
      >
        Terms & Conditions
      </a>
      ,{" "}
      <a
        rel="noreferrer"
        className="link"
        target="_blank"
        href="https://www.vippreferred.com/privacy-policy"
        onClick={() => linkClick("Privacy Notice")}
      >
        Privacy Notice
      </a>
      , and{" "}
      <a
        rel="noreferrer"
        className="link"
        target="_blank"
        href={GLBANOTICELINK}
        onClick={() => linkClick("GLBA Notice")}
      >
        GLBA Notice
      </a>
      .
    </div>
  );

  return termsLabel;
};

export default TermsAndConditions;
